import React from 'react';
import PropTypes from 'prop-types';
import css from './CwFlexbox.scss';
import cx from 'classnames';
import { AlignmentEnum } from '../../utils/Enums';

const CwFlexbox = (props) => {
  return (
    <div
      data-cwid={props.cwId}
      onClick={props.onClick}
      style={props.style}
      className={cx(css.wrap, props.className,
        {
          [css.column]: props.column,
          [css.verticalAlign]: props.verticalAlign,
          [css.horizontalAlign]: props.horizontalAlign,
          [css.leftAlign]: props.align === AlignmentEnum.LEFT,
          [css.centerAlign]: props.align === AlignmentEnum.CENTER,
          [css.rightAlign]: props.align === AlignmentEnum.RIGHT,
        }
      )}>
      {props.children}
    </div>
  );
};

CwFlexbox.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: PropTypes.string,
  column: PropTypes.bool,
  verticalAlign: PropTypes.bool,
  horizontalAlign: PropTypes.bool,
  align: PropTypes.oneOf([AlignmentEnum.LEFT, AlignmentEnum.CENTER, AlignmentEnum.RIGHT]),
  style: PropTypes.object,
  className: PropTypes.string,
  onClick: PropTypes.func
};

export default CwFlexbox;


// WEBPACK FOOTER //
// ./src/components/cwflexbox/CwFlexbox.jsx